<template>
  <div>
    <div v-if="isMobile=='pc'">
      <HomeMain></HomeMain>
    </div>

    <!-- 回到顶部与消息回复 -->
    <!-- <SideBtn></SideBtn> -->
    <div v-if="isMobile == 'mobile'">
      <Mobile-Home></Mobile-Home>
    </div>
  </div>
  
</template>

<script>
import Header from '@/components/header/Header.vue'
import Headers from '@/components/header/Headers.vue'
import Footer from '@/components/footer/Footer.vue'
import HomeMain from './HomeMain.vue'
import NavList from '@/components/navList/NavList.vue'
import SideBtn from '@/components/sideButton/sidewButton.vue'
import MobileHome from './MobileHome.vue'

import mixin from '@/mixins/scroll'

import { mapState, mapMutations } from 'vuex'
export default {
  mixins: [mixin],
  computed: {
    ...mapState(['isHideHead','screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  methods: {
    ...mapMutations([
      'updateIsHideHead',
      'updateIsArriveBottom',
      'updateisShowAD'
    ]),
    // 滚动事件
    scrolling() {
      // scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop
      // windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight
      // scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop

      // 更新——滚动前，滚动条距文档顶部的距离
      this.oldScrollTop = scrollTop
      if (scrollTop > 120 && scrollStep > 0) {
        this.updateIsHideHead(true)
      } else {
        this.updateIsHideHead(false)
      }

      // 回到顶部按钮出现的时机
      if (scrollTop > 500) {
        this.updateIsArriveBottom(true)
      } else {
        this.updateIsArriveBottom(false)
      }

      // 广告的显示时机
      if (scrollTop > 1500) {
        this.updateisShowAD(true)
      } else {
        this.updateisShowAD(false)
      }

      // 滚动条到底部的条件
      if (scrollHeight - scrollTop - windowHeight < 100) {
        // 请求新数据
        this.$bus.$emit('homeToBottom')
      }
    }
  },
  components: {
    Header,
    HomeMain,
    NavList,
    SideBtn,
    Footer,
    MobileHome,
    Headers
  }
}
</script>

<style lang="less" scoped>
.home-container {
  // width: 100%;
  width: 1000px;
  // transform: scale(1.246);
  transform-origin: top left;
  margin: 0 0;
  font-family: Microsoft YaHei UI;
}

.home-main {
  // height: calc(100vh - 24.1rem);
  // overflow: auto !important;
  margin-top: 5rem;
}
.header-fixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
}
</style>
